export const extractJSONFromSections = message => {
  const sections = message === null || message === void 0 ? void 0 : message.sections;
  if (!sections) {
    return undefined;
  }
  const htmlSection = sections.find(section => 'type' in section && section.type === 'HTML');
  const jsonString = htmlSection && 'text' in htmlSection ? htmlSection.text : undefined;
  if (!jsonString) {
    return undefined;
  }

  // Remove the DIV that hides the JSON string using regex
  const jsonStringWithoutDiv = jsonString.replace(/<div[^>]*>/i, '') // Matches opening div tag with any attributes
  .replace(/<\/div>/i, ''); // Matches closing div tag

  try {
    return JSON.parse(jsonStringWithoutDiv);
  } catch (error) {
    console.error('Failed to parse JSON from sections:', error);
    return undefined;
  }
};
export const extractContentFromPlainTextSections = message => {
  const sections = message === null || message === void 0 ? void 0 : message.sections;
  if (!sections || sections.length === 0) {
    return undefined;
  }
  return sections.filter(section => section.type === 'PLAIN_TEXT').map(section => section.text).filter(text => text !== undefined);
};